import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import * as R from 'ramda';

export const hideMobileFramesColorFilter = (coreApi: CoreApi, products: Product[]) => {
  const frames = products.filter(p =>
    [
      ProductType.KNOXHULT_CABINET_ASM,
      ProductType.KNOXHULT_CORNER_CABINET_ASM,
      ProductType.KNOXHULT_SINK_CABINET_ASM,
      ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
      ProductType.KNOXHULT_NICHE_CABINET_ASM,
      ProductType.KNOXHULT_HIGH_CABINET_ASM,
      ProductType.KNOXHULT_WALL_CABINET_ASM
    ].includes(p.type)
  );
  return R.uniq(frames.map(frame => frame.design)).length <= 1;
};
